'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var buffer = require('buffer');
var program = require('./program.cjs');
var Pda = require('../../types/Pda.cjs');

/** @group Pdas */
const findCandyMachineV2CreatorPda = (candyMachine, programId = program.CandyMachineV2Program.publicKey) => {
  return Pda.Pda.find(programId, [buffer.Buffer.from('candy_machine', 'utf8'), candyMachine.toBuffer()]);
};

/** @group Pdas */
const findCandyMachineV2CollectionPda = (candyMachine, programId = program.CandyMachineV2Program.publicKey) => {
  return Pda.Pda.find(programId, [buffer.Buffer.from('collection', 'utf8'), candyMachine.toBuffer()]);
};

exports.findCandyMachineV2CollectionPda = findCandyMachineV2CollectionPda;
exports.findCandyMachineV2CreatorPda = findCandyMachineV2CreatorPda;
//# sourceMappingURL=pdas.cjs.map
